import { createBackgroundColorFunctions as c } from "./index.es71.js";
import { createExternalTooltipHandler as u } from "./index.es72.js";
const x = '"ars_maquette_web_one", Arial, sans-serif;', g = (e, n) => {
  const o = e.split(/\s+/);
  if (!o.length)
    return [];
  const t = [o.shift() || ""];
  for (const r of o) {
    const l = t[t.length - 1];
    r.length + 1 + l.length <= n ? t[t.length - 1] = `${l} ${r} ` : t.push(r);
  }
  return t;
}, p = (e, n) => {
  const o = e.unitsName ? ` ${e.unitsName}` : e.currentUnits === "Percent" ? "%" : e.currentUnits === "Per 1000" ? " pr. 1000" : "", t = u(n), r = e.legendElementId ? {
    legend: { display: !1 },
    htmlLegend: { containerID: e.legendElementId }
  } : {
    legend: {
      display: !0,
      position: "bottom",
      align: "start",
      textAlign: "left",
      labels: {
        boxWidth: 25,
        boxHeight: 25,
        textAlign: "left",
        align: "left",
        padding: 10
      },
      title: {
        display: !!e.legendTitle,
        font: {
          size: 16,
          family: x
        },
        text: e.legendTitle
      }
    }
  }, l = e.annotations && e.annotations.length ? {
    annotation: {
      annotations: e.annotations.map((a, i) => ({
        type: "line",
        id: `line${i}`,
        xMin: a.value,
        xMax: a.value,
        label: {
          rotation: 90,
          content: a.text,
          display: !0,
          color: "#000",
          position: "end",
          xAdjust: 14,
          backgroundColor: "transparent",
          font: {
            weight: "normal"
          }
        },
        borderColor: "#000",
        borderWidth: 2
      })).reduce((a, i) => ({ ...a, [i.id]: i }), {})
    }
  } : {};
  return {
    chartJsBackgroundColorPlugin: {
      backgroundColor: e.chartBackgroundColor || "transparent",
      chartAreaBackgroundColor: e.chartAreaBackgroundColor || "#fff"
    },
    yScaleTitlePlugin: {
      title: e.yTitle || "",
      enabled: !!e.yTitle
    },
    title: {
      display: !!e.title,
      text: e.title
    },
    ...r,
    ...l,
    tooltip: {
      enabled: !1,
      external: t,
      position: "nearest",
      callbacks: {
        label: function(a) {
          let i = a.dataset.label || "";
          i && (i += ": ");
          const s = e.indexAxis === "y" ? "x" : "y";
          if (a.parsed[s] !== null) {
            const d = Intl.NumberFormat("no-nb");
            i += `${d.format(
              a.parsed[s]
            )}${o}`;
          }
          return i;
        }
      }
    }
  };
}, y = (e) => {
  const n = {};
  if (e.xTicksMax) {
    const l = e.xTicksMax;
    n.maxRotation = 0, n.autoSkip = !1, n.callback = function(a) {
      const i = this.getLabelForValue(a);
      return typeof i == "string" && i.length > l ? g(i, l) : i;
    };
  }
  const o = e.isStacked ? { stacked: !0 } : {}, t = { ...n, autoSkip: !0, maxRotation: 45 }, r = {
    ...n,
    crossAlign: "far"
  };
  return {
    x: {
      ...o,
      ticks: t,
      ..."yMax" in e && e.indexAxis === "y" ? { suggestedMax: e.yMax } : {},
      font: {
        size: 16
      },
      title: {
        display: !!e.xTitle,
        text: e.xTitle || ""
      },
      grid: {
        offset: !0
      },
      border: {
        width: e.xBorderWidth || 0,
        color: e.xBorderColor || "transparent"
      },
      ...e.isStacked && "yMax" in e && e.indexAxis === "y" ? { max: e.yMax } : {}
    },
    y: {
      ...o,
      ticks: r,
      ...typeof e.suggestedMin == "number" ? { suggestedMin: e.suggestedMin } : {},
      ..."yMax" in e && e.indexAxis !== "y" ? { suggestedMax: e.yMax } : {},
      display: !0,
      border: {
        width: e.yBorderWidth || 0,
        color: e.yBorderColor || "transparent"
      },
      font: {
        size: 16
      },
      ...e.isStacked && "yMax" in e && e.indexAxis !== "y" ? { max: e.yMax } : {},
      title: {
        display: !1,
        text: e.yTitle || ""
      }
    }
  };
}, f = (e, n, o) => ({
  bar: {
    backgroundColor: n
  },
  line: {
    backgroundColor: n,
    borderColor: o,
    tension: "lineTension" in e ? e.lineTension : 0
  },
  point: {
    radius: "pointRadius" in e ? e.pointRadius : 5,
    hoverRadius: "pointHoverRadius" in e ? e.pointHoverRadius : 8,
    backgroundColor: o
  }
}), h = (e) => {
  const { background: n, colorString: o, border: t } = c(
    e.backgroundColorInit
  ), r = {
    maintainAspectRatio: !0,
    aspectRatio: 1.1
  };
  return {
    locale: "nb-NO",
    maintainAspectRatio: !1,
    ...e.indexAxis === "y" ? r : {},
    responsive: !0,
    plugins: p(e, o),
    scales: y(e),
    elements: f(e, n, t),
    indexAxis: e.indexAxis,
    layout: {
      padding: {
        top: 40,
        bottom: 0
      }
    }
  };
};
export {
  h as createChartOptions,
  g as splitToMaxLength
};
//# sourceMappingURL=index.es70.js.map
